import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import classes from "./ActivityDetails.module.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { testUrl } from "../BaseData";

// DB da "https//" (ikki nuqtasiz) saqlangan URLlarni to'g'irlash
const fixSrc = (src) => {
  if (!src) return src;
  src = src.replace(/^(https?)\/\/([^/])/, "$1://$2");
  const doubleMatch = src.match(/https?:\/\/.+?(https?:\/\/.+)$/);
  if (doubleMatch) return doubleMatch[1];
  if (src.startsWith("/")) return testUrl + src;
  return src;
};

const fixHtml = (html) => {
  if (!html) return "";
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    doc.querySelectorAll("img").forEach((img) => {
      img.setAttribute("src", fixSrc(img.getAttribute("src") || ""));
    });
    doc.querySelectorAll("a[href]").forEach((a) => {
      a.setAttribute("href", fixSrc(a.getAttribute("href") || ""));
    });
    return doc.body.innerHTML;
  } catch {
    return html;
  }
};


const ActivityDetail = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const currentLang = i18n.language;

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios.get(testUrl + "/api/activity/" + id)
      .then((response) => {
        setData(response.data.activity);
        setActivities(response.data.activities);
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
    console.log(activities);
  }, [id, currentLang]);

  console.log(activities)


  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!data) return <div>Maqola topilmadi</div>;

  return (
    <div className={classes["detail-container"]}>
      {!["199", "196", "195"].includes(id?.trim()) && (
        <div className={classes["related-articles"]}>
          <h3 className={classes["sidebar-title"]}>
            {t("Aloqador")}
          </h3>
          <ul>
            {activities.map((relatedItem) => (
              <li key={relatedItem.id}>
                <Link
                  to={`/activity/${relatedItem.id}`}
                  className={classes["related-link"]}
                >
                  <div className={classes["related-card"]}>
                    <img
                      src={relatedItem.image}
                      alt={relatedItem[`name_${i18n.language}`]}
                      className={classes["related-image"]}
                    />
                    <div>{relatedItem[`name_${i18n.language}`]}</div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className={classes["article-content"]}>
        <h1 className={classes["article-title"]}>{data[`name_${currentLang}`]}</h1>

        <div className={classes["article-body"]} dangerouslySetInnerHTML={{ __html: fixHtml(data[`content_${currentLang}`]) }} />

        {data.files && data.files.length > 0 && (
          <div className={classes["files-section"]}>
            <ul className={classes["files-list"]}>
              {data.files.map((file) => (
                <li key={file.id} className={classes["file-item"]}>
                  <a href={file.file} target="_blank" rel="noopener noreferrer">
                    <span className={classes["file-name"]}>
                      {file[`name_${currentLang}`] || file.file.split('/').pop()}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityDetail;
